import { FilledNegativeIcon, FilledPositiveIcon, NegativeIcon, NeutralIcon, PositiveIcon } from 'assets';
import { customerLookupMessages } from 'messages/customer-lookup.message';
import { twMerge } from 'tailwind-merge';
import { colorsBase } from 'themes';
import { CONTACT_SENTIMENT } from 'utils/enums';

export const AIContactEvaluationOption = {
  [CONTACT_SENTIMENT.NEGATIVE]: {
    label: customerLookupMessages.negative,
    value: CONTACT_SENTIMENT.NEGATIVE,
    color: colorsBase.error,
    muted: colorsBase.errorMuted,
    iconFilled: (size: number) => <FilledNegativeIcon width={size} height={size} />,
    icon: (size: number, className?: string) => (
      <NegativeIcon width={size} height={size} className={twMerge('text-[#D1131D]', className)} />
    )
  },

  [CONTACT_SENTIMENT.POSITIVE]: {
    label: customerLookupMessages.positive,
    value: CONTACT_SENTIMENT.POSITIVE,
    color: colorsBase.success,
    muted: colorsBase.successMuted,
    iconFilled: (size: number) => <FilledPositiveIcon width={size} height={size} />,
    icon: (size: number, className?: string) => (
      <PositiveIcon width={size} height={size} className={twMerge('text-[#06a77d]', className)} />
    )
  },
  [CONTACT_SENTIMENT.NEUTRAL]: {
    label: customerLookupMessages.neutral,
    value: CONTACT_SENTIMENT.NEUTRAL,
    color: colorsBase.subTextColor,
    muted: colorsBase.lineColor2,
    iconFilled: (size: number) => <NeutralIcon className='bg-white' width={size} height={size} />,
    icon: (size: number, className?: string) => (
      <NeutralIcon width={size} height={size} className={twMerge('text-[#06a77d]', className)} />
    )
  }
};
